/**
 * Styles for the CryptoQuant components
 */
export const cryptoQuantStyles = {
  container: {
    px: 8,
    pt: 6,
    maxW: '100%'
  },
  heading: {
    mb: 4,
    fontSize: '2xl'
  },
  subheading: {
    mb: 6,
    color: 'gray.400',
    fontSize: 'md'
  },
  tableContainer: {
    position: 'relative',
    border: '1px',
    borderColor: 'whiteAlpha.200',
    borderRadius: 'md',
    overflow: 'hidden',
    marginLeft: -8,
    marginRight: -8,
    width: 'calc(100% + 16px)'
  },
  errorAlert: {
    mb: 4
  }
} as const
